module.exports = __webpack_public_path__ + "static/media/3-stars_icon.69743c46.svg";